import { Menu, Portal } from '@chakra-ui/react';

import { ButtonIcon } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { Nullable } from 'shared_DEPRECATED/types';

import { SessionsTableMoreOptionsCancelMenuItem } from 'features/sessions/components/Table/MoreOptions/CancelSessionMenuItem';
import { SessionsTableMoreOptionsDeleteMenuItem } from 'features/sessions/components/Table/MoreOptions/DeleteSessionMenuItem';
import { SessionsTableMoreOptionsRescheduleMenuItem } from 'features/sessions/components/Table/MoreOptions/RescheduleSessionMenuItem';
import { SESSION_ATTENDANCE_STATUS } from 'features/sessions/config';
import { SessionAttendanceStatusType } from 'features/sessions/config/types';
import { useParticipantCoachingMode } from 'features/sessions/hooks/useParticipantCoachingMode';
import { useSessionsPageCancelSessionMutateOptions } from 'features/sessions/hooks/useSessionsPageCancelSessionMutateOptions';
import { useSessionsPageRescheduleMutateOptions } from 'features/sessions/hooks/useSessionsPageRescheduleMutateOptions';

import { Show } from 'shared/components/Show';

type SessionsTableMoreOptionsMenuProps = {
  sessionId: string;
  sessionStartAt: Nullable<string>;
  sessionEndAt: Nullable<string>;
  attendance: SessionAttendanceStatusType;
};

export const SessionsTableMoreOptionsMenu = ({
  attendance,
  sessionId,
  sessionStartAt,
  sessionEndAt,
}: SessionsTableMoreOptionsMenuProps) => {
  const cancelMutateOptions =
    useSessionsPageCancelSessionMutateOptions(sessionId);
  const rescheduleMutateOptions =
    useSessionsPageRescheduleMutateOptions(sessionId);
  const coachingMode = useParticipantCoachingMode();

  return (
    <Menu.Root placement="bottom-start">
      <Menu.Trigger asChild>
        <ButtonIcon
          aria-label="more-options"
          _hover={{
            bg: 'gray.200',
          }}
          variant="ghost"
          size="sm"
          onClick={(evt: React.MouseEvent<HTMLButtonElement>) => {
            evt.stopPropagation();
          }}
        >
          <Icon name={iconNames.dotsVert} />
        </ButtonIcon>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content>
            <Show
              when={
                attendance === SESSION_ATTENDANCE_STATUS.ATTENDED ||
                attendance === SESSION_ATTENDANCE_STATUS.SCHEDULED ||
                attendance === SESSION_ATTENDANCE_STATUS.RESCHEDULED
              }
            >
              <SessionsTableMoreOptionsRescheduleMenuItem
                sessionId={sessionId}
                sessionStartAt={sessionStartAt!}
                sessionEndAt={sessionEndAt!}
                options={rescheduleMutateOptions}
                coachingMode={coachingMode}
              />
              <SessionsTableMoreOptionsCancelMenuItem
                sessionId={sessionId}
                options={cancelMutateOptions}
              />
            </Show>
            <SessionsTableMoreOptionsDeleteMenuItem sessionId={sessionId} />
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};
